interface PerformancesProps {
  onBookClick: () => void;
}

export default function Performances({ onBookClick }: PerformancesProps) {
  const performances = [
    {
      id: 1,
      title: 'COMEDY',
      subtitle: 'Sharp wit meets French charm',
      icon: 'ri-emotion-laugh-line',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/66fed5a70ff519876d4785bfe25987f5.jpeg',
      description: 'Experience humor that transcends language barriers. Thomas\'s comedy combines observational wit, physical humor, and interactive audience engagement that keeps everyone entertained from start to finish.'
    },
    {
      id: 2,
      title: 'MENTALISM',
      subtitle: 'Reading minds, revealing secrets',
      icon: 'ri-brain-line',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/d0829845be4c9f887ca3312849d9f8d7.jpeg',
      description: 'Witness the impossible as Thomas demonstrates extraordinary mental abilities. Through psychological techniques and intuition, he reveals thoughts, predicts choices, and creates moments of genuine astonishment.'
    },
    {
      id: 3,
      title: 'MAGIC',
      subtitle: 'Illusions that defy reality',
      icon: 'ri-magic-line',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/36d336f6456511080050318e3ceeba0a.jpeg',
      description: 'Marvel at sleight of hand and grand illusions that challenge perception. From close-up magic to stage spectacles, Thomas creates magical moments that blur the line between reality and impossibility.'
    }
  ];

  return (
    <section id="performances" className="relative py-32 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-20 gap-8">
          <div>
            <h2 className="text-6xl md:text-7xl font-bold text-white leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Three Acts,<br />
              <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
                One Show
              </span>
            </h2>
          </div>
          
          <div className="max-w-xs">
            <p className="text-gray-400 text-base leading-relaxed">
              Each performance is a unique journey through laughter, mystery, and wonder
            </p>
          </div>
        </div>

        {/* Performance Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {performances.map((performance) => (
            <div 
              key={performance.id}
              onClick={onBookClick}
              className="group bg-zinc-900 rounded-2xl border border-red-900/30 overflow-hidden hover:border-red-600 hover:shadow-2xl hover:shadow-red-600/20 transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              {/* Image Area */}
              <div className="relative h-80 overflow-hidden bg-white">
                <img 
                  src={performance.image}
                  alt={performance.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-transparent to-transparent opacity-60"></div>
              </div>

              {/* Content Area */}
              <div className="p-6">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-600/10 mb-4">
                  <i className={`${performance.icon} text-2xl text-red-500`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {performance.title}
                </h3>
                
                <p className="text-red-400 text-sm mb-4 font-medium">
                  {performance.subtitle}
                </p>
                
                <p className="text-gray-400 text-sm leading-relaxed">
                  {performance.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
